var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9.5,
    r: 6.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 9.5,
    r: 6.125,
    stroke: "black",
    strokeOpacity: 0.87,
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.59391 12C6.5469 12 6.5007 11.9878 6.45991 11.9647C6.41912 11.9415 6.38514 11.9082 6.36134 11.868C5.46529 10.3546 3.07644 7.1321 3.05244 7.09972C3.01407 7.048 2.99575 6.98432 3.00083 6.92031C3.00592 6.8563 3.03407 6.79625 3.08014 6.75112L3.8147 6.03146C3.85957 5.98751 3.91855 5.96054 3.98139 5.95524C4.04424 5.94994 4.10696 5.96665 4.15867 6.00245L6.53779 7.64935C8.12978 5.62549 9.60856 4.22723 10.5814 3.40216C11.6767 2.47343 12.374 2.05532 12.4032 2.0381C12.4451 2.01317 12.493 2 12.5419 2H13.7303C13.785 2 13.8384 2.01647 13.8834 2.04723C13.9284 2.07799 13.9629 2.12158 13.9824 2.17224C14.0018 2.22289 14.0053 2.27821 13.9923 2.33086C13.9793 2.38351 13.9505 2.431 13.9096 2.46704C10.5349 5.44706 6.8649 11.8011 6.82823 11.865C6.80481 11.9057 6.771 11.9396 6.73017 11.9633C6.68935 11.987 6.64296 11.9997 6.59566 12L6.59391 12Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestApproval);
export default __webpack_public_path__ + "static/media/requestApproval.19c679521393e5dff0837ff0f09a9dda.svg";
export { ForwardRef as ReactComponent };